import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import MyPieChart from "../chart/PieChart";
import MyLineChart from "../chart/LineChart";
import MyChart from "../chart/Chart";
import api from "../hooks/apiClient";
import MonthYearPicker from "../components/YearMonthSelector";
import dayjs from "dayjs";
import { useClientId } from "../authContext/ClientIdContext";

export default function BarAnimation() {
  const { clientId } = useClientId();
  const [lineData, setLineData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [chartData, setChartData] = useState();
  const [selectedDate, setSelectedDate] = useState(dayjs());

  async function fetchData(selectedMonth = selectedDate) {
    try {
      const response = await api.get(`orders/all/${clientId}`, {
        params: {
          year: selectedMonth.format("YYYY"),
          month: selectedMonth.format("MM"),
        },
      });

      setLineData(response.data.lineData);
      setPieData(response.data.pieData);
      setChartData(response.data.chartData);
    } catch (err) {
      console.error("Error fetching chart data:", err);
    }
  }
  useEffect(() => {
    fetchData();
  }, [selectedDate]);

  return (
    <Box mt={6} sx={{ width: "100%" }}>
      <Grid container spacing={2} rowSpacing={5}>
        {/* First row: Date Pickers */}
        <Grid item xs={12}>
          <Box my={1} display="flex" alignItems="center" gap={1} p={1}>
            {/* <MyDatePicker
              selectedDate={selectedDate}
              onDateChange={handleDateChange}
              label="Pick Start date"
            /> */}

            <MonthYearPicker
              label="Select Month & Year"
              value={selectedDate}
              onChange={setSelectedDate}
            />

            {/* <MyDatePicker
              selectedDate={selectedDateEnd}
              onDateChange={handleDateChangeEnd}
              label="Pick End date"
            /> */}
          </Box>
        </Grid>

        {/* Second row: Bar Chart (full width) */}
        <Grid item xs={12} md={4}>
          <MyChart data={chartData} />
        </Grid>

        {/* Third row: Line Chart and Pie Chart side by side */}
        <Grid item xs={12} md={4}>
          <MyLineChart data={lineData} />
        </Grid>
        <Grid item xs={12} md={4}>
          <MyPieChart pieData={pieData} />
        </Grid>
      </Grid>
    </Box>
  );
}
